/* =========================================================
   "Add one & get FREE shipping" suggestions
   - Add buttons in the cart drawer and on the cart page
   - "View more products" / "Show less" toggle
   ========================================================= */
(function () {
  'use strict';
  if (window.__fsUpsellReady) return;
  window.__fsUpsellReady = true;

  var MORE_KEY = 'fsUpsellMoreOpen';

  function isMoreOpen() {
    try { return window.sessionStorage.getItem(MORE_KEY) === '1'; } catch (e) { return false; }
  }
  function setMoreOpen(open) {
    try { window.sessionStorage.setItem(MORE_KEY, open ? '1' : '0'); } catch (e) {}
  }

  /* Show or hide every "View more" panel inside root, based on the saved choice */
  function applyMoreState(root) {
    var open = isMoreOpen();
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-fs-more-toggle]'), function (toggle) {
      var panel = toggle.parentNode.querySelector('[data-fs-more]');
      if (!panel) return;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = toggle.querySelector('[data-fs-more-label]');
      if (label) label.textContent = open ? 'Show less' : label.getAttribute('data-more-text');
    });
  }

  function updateCartCount(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = cart.item_count;
    });
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-cart-drawer]');
        var current = document.querySelector('[data-cart-drawer]');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var toggle = event.target.closest('[data-fs-more-toggle]');
    if (toggle) {
      event.preventDefault();
      setMoreOpen(toggle.getAttribute('aria-expanded') !== 'true');
      applyMoreState(document);
      return;
    }

    var button = event.target.closest('[data-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    var context = button.getAttribute('data-upsell-context');
    var originalHtml = button.innerHTML;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not add to cart');
        return r.json();
      })
      .then(function () {
        if (context === 'page') {
          window.location.reload();
          return null;
        }
        button.textContent = 'Added ✓';
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart);
            return refreshDrawer();
          });
      })
      .catch(function () {
        button.disabled = false;
        button.innerHTML = originalHtml;
        window.location.href = '/cart';
      });
  });

  /* Keep the "View more" choice when the cart drawer is re-drawn */
  function init() {
    applyMoreState(document);
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { applyMoreState(drawer); }).observe(drawer, { childList: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
